import { Button, Input } from "antd";
import React, { useState, useEffect } from "react";
import { useMoralis } from "react-moralis";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";

function Airdrop() {
    const [addresses, setAddresses] = useState(null);
    const [tokenId, setTokenId] = useState(1);
    const [amount, setAmount] = useState(1);
    const { marketAddressPass, contractABIPass } = useMoralisDapp();
    const contractABIPassJson = JSON.parse(contractABIPass);
    const { Moralis } = useMoralis();

    const airdrop = "airdrop";

      

    async function submit()
    {
        const addressValues = addresses.split("\n");
        console.log(tokenId)
            const ops = {
              contractAddress: marketAddressPass,
              functionName: airdrop,
              abi: contractABIPassJson,
              params: {
                tokenId: tokenId,
                account: addressValues,
                amount: amount
              },
            };
            try {
              const res = await Moralis.executeFunction(ops);
              console.log("result", res);
            } catch (e) {
              console.log(e);
            }
    }
    return(
        <div>
            <form>
                <textarea cols="50" rows="10" onChange={(e) => setAddresses(e.target.value)}></textarea>
                <Input
                    autoFocus
                    placeholder="Enter Token"
                    onChange={(e) => setTokenId(e.target.value)}
                />
                <Input
                    autoFocus
                    placeholder="Enter Amount"
                    onChange={(e) => setAmount(e.target.value)}
                />
                <Button
                    className="primary-button text-white claim-button pass-desc mb-3"
                    onClick={() => submit()}
                    size="large"
                  >
                    CLAIM
                  </Button>
            </form>
        </div>
    )
}

export default Airdrop;